import { RepairEstimate } from "@/models/repair-estimate.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";
import { InvoiceLine } from "@/models/invoice-line.entity";
import VueI18n from "@/plugins/I18nPlugin";
import repairEstimateRequestService from "@/services/mrfiktiv/services/repair-estimate-request.service";

export class RepairEstimateFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.REPAIR_ESTIMATE;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.REPAIR_ESTIMATE, async () => {
      const response = await repairEstimateRequestService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      const request = new RepairEstimate(response);

      // Add default first position to request
      if (!request.lineItems || !request.lineItems.length) {
        request.lineItems = [
          new InvoiceLine({
            title: VueI18n.t("components.RepairEstimateResponseCard.defaultPosition").toString()
          })
        ];
      }

      return request;
    });
  }
}
